import { DataSource } from "@angular/cdk/collections";
import { NefcoPagedDataSource } from 'src/app/shared/helpers/nefco-data-source.class';
import { EvidenceReportService } from './evidence-report.service';
import { ApiConnection } from 'src/app/shared/decorators/@ApiConnection.decorator';
import { IApiInvestigationMetrics, IApiInvestigationMetricsConnection } from "src/app/shared/modules/graphql/types/types";
import { IApiInvestigationMetricsFilter } from "src/app/shared/modules/graphql/types/types";

export class EvidenceReportDataSource extends NefcoPagedDataSource<IApiInvestigationMetrics, EvidenceReportService, IApiInvestigationMetricsConnection> implements DataSource<IApiInvestigationMetrics> {
  @ApiConnection()
  public load(filters: IApiInvestigationMetricsFilter[] = []): Promise<IApiInvestigationMetricsConnection> {
    return this.service.get(filters, this.listPage).toPromise();
  }
}
